const projectStatusOptions = [
  {
    value: 'draft',
    label: 'Draft',
    icon: 'draft',
    iconLibrary: 'material',
    description: 'Project still being configured, limited functionality',
  },
  {
    value: 'live',
    label: 'Live',
    icon: 'online_prediction',
    iconLibrary: 'material',
    description: 'Active and collaborating',
  },
  {
    value: 'archived',
    label: 'Archived',
    icon: 'inventory_2',
    iconLibrary: 'material',
    description: 'Still visible to members but inactive',
  },
  {
    value: 'deleted',
    label: 'Deleted',
    icon: 'delete',
    iconLibrary: 'material',
    description: 'Removed from the network',
  },
];
const projectStatusMap = Object.fromEntries(projectStatusOptions.map((o) => [o.value, o]));

const projectActivationStatusOptions = [
  { 
    value: 'created', 
    label: 'Draft', 
    icon: 'pending', 
    iconLibrary: 'material', 
    description: 'This is a draft project and is not yet available for interaction.',
    organizerNotes: 'Project is in draft mode and cannot have members other than the point. Must be published before members can be invited.',
    tagVariant: 'default',
  },
  { 
    value: 'published', 
    label: 'Published', 
    icon: 'offline_bolt', 
    iconLibrary: 'material', 
    description: 'This project is published, but still in the process of being activated.',
    organizerNotes: 'Project is private, but live and can have members. To reach activated status, onboard 2 members and post 3 log updates.',
    tagVariant: 'primary',
  },
  { 
    value: 'activated', 
    label: 'Activated', 
    icon: 'brightness_5', 
    iconLibrary: 'material', 
    description: 'This in an active project.',
    organizerNotes: 'Project is activated and gets increased visibility. A custom URL may be claimed. The Q1 Foundation team is available to organize an official launch.',
    tagVariant: 'warning',
  },
  { 
    value: 'launched', 
    label: 'Launched', 
    icon: 'brightness_7', 
    iconLibrary: 'material', 
    description: 'This project is fully launched and active.',
    organizerNotes: 'Project is fully launched and active. Launched projects have the highest level of visibility & discoverability, and receive more support from the network.',
    tagVariant: 'warning',
  },
  { 
    value: 'retired', 
    label: 'Retired', 
    icon: 'do_not_disturb_on', 
    iconLibrary: 'material',
    description: 'This project has been retired and is no longer active.',
    description: 'Project is still available to old members, but is no longer active.',
    tagVariant: 'danger',
  },
];
const projectActivationStatusMap = Object.fromEntries(
  projectActivationStatusOptions.map((o) => [o.value, o])
);

const projectVisibilityOptions = [
  { 
    value: 'public',
    label: 'Public',
    icon: 'public',
    iconLibrary: 'material',
    description: 'Visible on the public internet',
    availableAt: ['activated', 'launched'],
  },
  {
    value: 'network',
    label: 'Network',
    icon: 'q1-logo',
    iconLibrary: 'q1',
    description: 'Visible to members of the q1 Network',
    availableAt: ['activated', 'launched'],
  },
  {
    value: 'project-network',
    label: 'Project Network',
    icon: 'hub',
    iconLibrary: 'material',
    description: 'Visible to members & followers of the project, plus members of connected guilds',
    availableAt: ['published', 'activated', 'launched'],
  },
  {
    value: 'link',
    label: 'Private Link',
    icon: 'link',
    iconLibrary: 'material',
    description: 'Project is private & unlisted, visible to any q1 Network members with link.',
    availableAt: ['created', 'published', 'activated', 'launched'],
  },
  {
    value: 'private',
    label: 'Private',
    icon: 'communities',
    iconLibrary: 'material',
    description: 'Only visible to members',
    availableAt: ['created', 'published', 'activated', 'launched'],
  },
];
const projectVisibilityMap = Object.fromEntries(
  projectVisibilityOptions.map((o) => [o.value, o])
);

const projectJoinabilityOptions = [
  {
    value: 'open',
    label: 'Open',
    icon: 'handshake',
    iconLibrary: 'material',
    description: 'Anyone who can see the project can join the project directly.',
    requestable: true,
  },
  {
    value: 'request',
    label: 'By Request',
    icon: 'person_raised_hand',
    iconLibrary: 'material',
    description: 'Anyone who can see the project can request to join, organizers must approve.',
    requestable: true,
  },
  {
    value: 'invite',
    label: 'By Invitation',
    icon: 'lock',
    iconLibrary: 'material',
    description: 'By organizer invitation only.',
    requestable: false,
  },
];
const projectJoinabilityMap = Object.fromEntries(projectJoinabilityOptions.map((o) => [o.value, o]));

const projectTextColorOptions = [
  { value: 'black', label: 'Black' },
  { value: 'white', label: 'White' },
];
const projectTextColorMap = Object.fromEntries(
  projectTextColorOptions.map((o) => [o.value, o])
);

/*=== EXPORTS ===*/

export {
  projectStatusOptions,
  projectStatusMap,

  projectActivationStatusOptions,
  projectActivationStatusMap,

  projectVisibilityOptions,
  projectVisibilityMap,
  
  projectJoinabilityOptions,
  projectJoinabilityMap,
  
  projectTextColorOptions,
  projectTextColorMap,
};
